import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { environment } from '#environments';
import { Dtos } from '#models';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private http = inject(HttpClient);

  public getCategoryById(id: number): Observable<Dtos.ActionItemCategory> {
    return this.http.get<Dtos.ActionItemCategory>(`${environment.apiUrl}/category/${id}`);
  }

  public createCategory(category: Dtos.Category): Observable<Dtos.Category> {
    return this.http.post<Dtos.Category>(`${environment.apiUrl}/category`, category);
  }

  public updateCategory(category: Dtos.Category): Observable<Dtos.Category> {
    return this.http.put<Dtos.Category>(`${environment.apiUrl}/category`, category);
  }

  public deleteCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/category/${id}`);
  }
}
